import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { GridModule } from '@progress/kendo-angular-grid';
import { TranslateModule } from '@ngx-translate/core';
import { OutlookSyncHistoryEntry } from '@maximizer/outlook-sync/data-access';

@Component({
  selector: 'maximizer-history-grid',
  standalone: true,
  imports: [
    CommonModule,
    ButtonsModule,
    GridModule,
    TranslateModule,
  ],
  templateUrl: './history-grid.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HistoryGridComponent {
  history = input<OutlookSyncHistoryEntry[]>([]);
  loading = input(false);
  inSyncColumnTitleKey = input(
    'outlookSync.history.columns.inSync',
  );
  showIgnored = input(false);
  boxed = input(true);

  refresh = output<void>();
}
